module.exports = __webpack_public_path__ + "static/Place of Rest-4a7b4d99d65885a57ab90f8b88ac2c16.jpg";